import { render, staticRenderFns } from "./createggroup.vue?vue&type=template&id=6b8cc002&scoped=true&"
import script from "./createggroup.vue?vue&type=script&lang=js&"
export * from "./createggroup.vue?vue&type=script&lang=js&"
import style0 from "./createggroup.vue?vue&type=style&index=0&id=6b8cc002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8cc002",
  null
  
)

export default component.exports